import axios from 'axios';
import _ from "lodash-es";

//Todo wait to fetch periodically? 0.1 seconds?
// Recursively deep freeze an object with circular references
const deepFreeze = (x, frozen = []) => {
  if (frozen.includes(x)) return null
  frozen.push(x)
  Object.freeze(x)
  Object.values(x).forEach(x => deepFreeze(x, frozen))
}

export default {
  //TODO ensure validity
  _copyEntity : null,
  _getByIdURL: null,
  _getByIdsURL: null,
  _store: null,
  fetchById: function (id, fetchEager, force) {
    if (this._store[id] && !force) {
      return this._store[id].then(value => _.cloneDeep(value));
    } else {
      var promise = axios.get(this._getByIdURL + id)
        .then(response => this._copyEntity(response.data, fetchEager));
      this._store[id] = promise;
      return promise;
    }
  },
  save: function(entity) {
    if (entity.id === "new") {
      entity.id = null;
      //TODO reroute to create method
    }
    return axios.post(this._saveUrl, entity).then(response => {
      this._store[response.data.id] = Promise.resolve(this._copyEntity(response.data));
      return this._store[response.data.id];
    });
  },
  fetchByIds: function (idArray, fetchEager) {
    if (idArray.length === 0) {
      return Promise.resolve([]);
    }
    let uniqueIds = Array.from(new Set(idArray));
    let toFetch = uniqueIds.filter(id => typeof this._store[id] === "undefined");
    let toFetchPromises = {};
    toFetch.forEach(id => {
      let promiseResolve;
      let promiseReject;
      let promise = new Promise((resolve, reject) => {promiseResolve = resolve; promiseReject = reject});
      toFetchPromises[id] = { promise: promise,
        promiseResolve : promiseResolve,
        promiseReject: promiseReject
      };
      this._store[id] = toFetchPromises[id].promise;
    });
    if (toFetch.length) {
      axios.post(this._getByIdsURL, toFetch)
        .then(response => {
          response.data.map(entity => this._copyEntity(entity, fetchEager)).forEach(copiedEntity => {
            //TODO throw/reject if not in toFetch
            toFetchPromises[copiedEntity.id].promiseResolve(copiedEntity);
          });
        });
    }
    return Promise.all(idArray.map(id => this._store[id]));
  }
}
